import React, { Component } from 'react';
import { Formik, Form, Field } from 'formik';
import SelectSearchField from '../../forms/SelectSearchField';
import { EditorState, convertToRaw } from 'draft-js';
import { DraftEmail } from "./DraftEmail";
import draftToHtml from 'draftjs-to-html';

import Message from "../../../store/wrappers/Message";


var stateFromHTML = require('draft-js-import-html').stateFromHTML;

class EmailStudent extends Component {

    constructor(props) {
        super(props);


        let contentState = stateFromHTML('<p>Dear student,<br><br></p>');

        this.state = {
            selectedStudentIds: [],
            editorState: EditorState.createWithContent(contentState),
            emailSubject: "",
            confirming: false
        }

        this.props.store.updateBanner("Message Student");

        this.onChangeSelection = this.onChangeSelection.bind(this);
        this.setEditorState = this.setEditorState.bind(this);
        this.confirmMessage = this.confirmMessage.bind(this);
        this.handleSubjectChange = this.handleSubjectChange.bind(this);

        this.cancelMessage = this.cancelMessage.bind(this);
        this.sendMessage = this.sendMessage.bind(this);
    }

    cancelMessage() {
        this.setState({ confirming: false })
    }

    handleSubjectChange(e) {
        this.setState({
            emailSubject: e.target.value
        })
    }

    sendMessage() {
        //Fun time
        let emailContent = convertToRaw(this.state.editorState.getCurrentContent());

        let html = draftToHtml(emailContent)

        let emailBody = JSON.stringify(html).replace(/\\n/g, '');
        //String extranous ""
        emailBody = emailBody.substring(1, emailBody.length - 2)

        let message = new Message({
            emailBody: emailBody,
            emailSubject: this.state.emailSubject,
            studentIds: this.state.selectedStudentIds
        });

        let newMessage = message.save(this.props.store);

        this.setState({
            confirming: false,
            selectedStudentIds: [],
            editorState: EditorState.createEmpty(),
            emailSubject: ""
        });

    }

    confirmMessage() {
        console.log(this.state.selectedStudentIds)

        if (Array.isArray(this.state.selectedStudentIds) && this.state.selectedStudentIds.length > 0) {
            this.setState({
                confirming: true
            });
        }
        else {
            window.alert("You must select one or more students.")
        }
    }

    setEditorState(newState) {
        this.setState({
            editorState: newState
        })
    }

    onChangeSelection(value) {
        console.log(value)
        if (!value.includes("<SELECT_ALL>")) {
            this.setState({ selectedStudentIds: value })
        }
        else {
            let studentIds = this.props.store.students.collection
                .map(student => student.id);

            this.setState({ selectedStudentIds: studentIds })
        }
    }

    studentSearch() {
        let students = this.props.store.students.collection;
        students.sort(this.props.store.students.sortByLastName);


        let options = students.map(student => {
            return {
                label: student.name,
                value: student.id
            }
        });

        const selectAllOption = {
            value: "<SELECT_ALL>",
            label: "All Students"
        };

        options.unshift(selectAllOption)


        return (
            <div className="col-12 col-md-4">
                <Formik
                    initialValues={{ studentId: this.state.selectedStudentIds }}
                    onSubmit={(values, { setSubmitting }) => this.onChangeSelection(values, setSubmitting)}
                >
                    <Form>
                        <label htmlFor="studentId">Select Student(s)</label>
                        <Field component={SelectSearchField} isMulti={true} onChange={(value) => this.onChangeSelection(value)} name="studentId" options={options} isClearable={true} />
                    </Form>
                </Formik>
                <button type="button" onClick={this.confirmMessage} className="mt-2 float-right btn btn-primary">Confirm</button>
            </div>
        )
    }

    render() {
        if (!this.state.confirming) {
            return (
                <div>
                    <div className="row">
                        <div className="col-12 col-md-8">
                            <div className="form-group">
                                <label htmlFor="emailSubject">Subject</label>
                                <input
                                    id="emailSubject"
                                    type="text"
                                    className="form-control"
                                    value={this.state.emailSubject}
                                    onChange={this.handleSubjectChange}
                                    placeholder="Enter email subject"
                                />
                            </div>
                            <DraftEmail
                                editorState={this.state.editorState}
                                setEditorState={this.setEditorState}
                            />
                        </div>
                        {this.studentSearch()}
                    </div>
                </div>
            );
        }
        else {
            let students = this.props.store.students.collection.filter(student => this.state.selectedStudentIds.includes(student.id));

            let emailContent = convertToRaw(this.state.editorState.getCurrentContent());

            return (
                <div className="confirmEmail">
                    <h2 className="h4">Confirm Email:</h2>
                    <div className="row">
                        <div className="comfirmEmailDisplay col-12 col-md-8">
                            <p><b>Subject:</b> {this.state.emailSubject || "Message from Summer Work Study"}</p>
                            <div dangerouslySetInnerHTML={{ __html: draftToHtml(emailContent) }}></div>
                        </div>
                        <div className="comfirmEmailControls col-12 col-md-4">
                            <h3 className="h5">Recipients</h3>
                            {students.map(student => (
                                <p>{`${student.name} - ${student.email}`}</p>
                            ))}

                            <div className="d-flex flex-row no-wrap">
                                <button type="button" onClick={this.cancelMessage} className="mt-2 btn btn-secondary ml-auto">Cancel</button>
                                <button type="button" onClick={this.sendMessage} className="mt-2 ml-2 btn btn-primary">Confirm</button>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }
}

export default EmailStudent;
// import React, { Component } from 'react';
// import { Formik, Form, Field } from 'formik';
// import SelectSearchField from '../../forms/SelectSearchField';
// import { EditorState, convertToRaw } from 'draft-js';
// import { DraftEmail } from "./DraftEmail";
// import draftToHtml from 'draftjs-to-html';

// import Message from "../../../store/wrappers/Message";


// var stateFromHTML = require('draft-js-import-html').stateFromHTML;

// class EmailStudent extends Component {

//     constructor(props) {
//         super(props);


//         let contentState = stateFromHTML('<p>Dear student,<br><br></p>');

//         this.state = {
//             selectedStudentIds: [],
//             editorState: EditorState.createWithContent(contentState),
//             emailSubject: "",
//             confirming: false
//         }

//         this.props.store.updateBanner("Message Student");

//         this.onChangeSelection = this.onChangeSelection.bind(this);
//         this.setEditorState = this.setEditorState.bind(this);
//         this.confirmMessage = this.confirmMessage.bind(this);

//         this.cancelMessage = this.cancelMessage.bind(this);
//         this.sendMessage = this.sendMessage.bind(this);
//     }

//     cancelMessage() {
//         this.setState({ confirming: false })
//     }

//     sendMessage() {
//         //Fun time
//         let emailContent = convertToRaw(this.state.editorState.getCurrentContent());

//         let html = draftToHtml(emailContent)

//         let emailBody = JSON.stringify(html).replace(/\\n/g, '');
//         //String extranous ""
//         emailBody = emailBody.substring(1, emailBody.length - 2)

//         let message = new Message({ emailBody: emailBody, studentIds: this.state.selectedStudentIds });

//         let newMessage = message.save(this.props.store);

//         this.setState({
//             confirming: false,
//             selectedStudentIds: [],
//             editorState: EditorState.createEmpty()
//         });

//     }

//     confirmMessage() {
//         console.log(this.state.selectedStudentIds)

//         if (Array.isArray(this.state.selectedStudentIds) && this.state.selectedStudentIds.length > 0) {
//             this.setState({
//                 confirming: true
//             });
//         }
//         else {
//             window.alert("You must select one or more students.")
//         }
//     }

//     setEditorState(newState) {
//         this.setState({
//             editorState: newState
//         })
//     }

//     onChangeSelection(value) {
//         console.log(value)
//         if (!value.includes("<SELECT_ALL>")) {
//             this.setState({ selectedStudentIds: value })
//         }
//         else {
//             let studentIds = this.props.store.students.collection
//                 .map(student => student.id);

//             this.setState({ selectedStudentIds: studentIds })
//         }
//     }

//     studentSearch() {
//         let students = this.props.store.students.collection;
//         students.sort(this.props.store.students.sortByLastName);


//         let options = students.map(student => {
//             return {
//                 label: student.name,
//                 value: student.id
//             }
//         });

//         const selectAllOption = {
//             value: "<SELECT_ALL>",
//             label: "All Students"
//         };

//         options.unshift(selectAllOption)


//         return (
//             <div className="col-12 col-md-4">
//                 <Formik
//                     initialValues={{ studentId: this.state.selectedStudentIds }}
//                     onSubmit={(values, { setSubmitting }) => this.onChangeSelection(values, setSubmitting)}
//                 >
//                     <Form>
//                         <label htmlFor="studentId">Select Student(s)</label>
//                         <Field component={SelectSearchField} isMulti={true} onChange={(value) => this.onChangeSelection(value)} name="studentId" options={options} isClearable={true} />
//                     </Form>
//                 </Formik>
//                 <button type="button" onClick={this.confirmMessage} className="mt-2 float-right btn btn-primary">Confirm</button>
//             </div>
//         )
//     }

//     render() {
//         if (!this.state.confirming) {
//             return (
//                 <div>
//                     <div className="row">
//                         <div className="col-12 col-md-8">
//                             <DraftEmail
//                                 editorState={this.state.editorState}
//                                 setEditorState={this.setEditorState}
//                             />
//                         </div>
//                         {this.studentSearch()}
//                     </div>
//                 </div>
//             );
//         }
//         else {
//             let students = this.props.store.students.collection.filter(student => this.state.selectedStudentIds.includes(student.id));

//             let emailContent = convertToRaw(this.state.editorState.getCurrentContent());

//             return (
//                 <div className="confirmEmail">
//                     <h2 className="h4">Confirm Email:</h2>
//                     <div className="row">
//                         <div className="comfirmEmailDisplay col-12 col-md-8" dangerouslySetInnerHTML={{ __html: draftToHtml(emailContent) }}></div>
//                         <div className="comfirmEmailControls col-12 col-md-4">
//                             <h3 className="h5">Recipients</h3>
//                             {students.map(student => (
//                                 <p>{`${student.name} - ${student.email}`}</p>
//                             ))}

//                             <div className="d-flex flex-row no-wrap">
//                                 <button type="button" onClick={this.cancelMessage} className="mt-2 btn btn-secondary ml-auto">Cancel</button>
//                                 <button type="button" onClick={this.sendMessage} className="mt-2 ml-2 btn btn-primary">Confirm</button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )
//         }
//     }
// }

// export default EmailStudent;